/*
 * Author M. Atoar Rahman
 * Title: Employee Information
 * Description: Page for Employee Information
 * Date: 30/04/2022
 */

import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { useEmployee } from './ContextAPI';
import DataTable from './DataTable';
import FormInfo from './FormInfo';

export default function Index() {
    const { show, setShow, rowData, setRowData } = useEmployee();
    const createHander = () => {
        setShow(true);
        setRowData('');
    };
    const backHander = () => {
        setShow(false);
        setRowData('');
    };
    return (
        <Card>
            <Card.Header className="cardHeader">
                <h3>Employee Information</h3>
                {show ? (
                    <div>
                        <Button onClick={() => backHander()} className="btnInfo" variant="primary">
                            Back to List
                        </Button>
                    </div>
                ) : (
                    <div>
                        <Button
                            onClick={() => createHander()}
                            className="btnInfo"
                            variant="primary"
                        >
                            Create New
                        </Button>
                    </div>
                )}
            </Card.Header>
            <Card.Body>{show ? <FormInfo editData={rowData} /> : <DataTable />}</Card.Body>
        </Card>
    );
}
